import React, { useEffect } from "react";
import { FiPlay } from "react-icons/fi";
import data from "../data/about.json";

import GLightbox from "glightbox";
import { socialLink } from "../global";

const Aboutv6 = ({ isBg }) => {
  const { aboutv6 } = data;
  useEffect(() => {
    GLightbox({
      selector: ".glightbox3",
    });
  }, []);

  return (
    // <!-- ========== Author section start ========== -->
    <section
      id="author"
      className={`section-padding authorv2 ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{aboutv6.subtitle}</span>
              <h2 className="display-6">{aboutv6.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row gx-5">
          <div
            className="col-lg-6 mb-4 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="authorv2__image">
              <img
                className="img-fluid"
                src="assets/images/sanjeetd.jpg"
                alt="Author"
              />
              {aboutv6.videoURL === "" ? (
                ""
              ) : (
                <>
                 
                  
                </>
              )}
            </div>
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <p>{aboutv6.description}</p>
            <div className="authorv2__content">
              <div className="authorv2__list">
                <div className="row">
                  {aboutv6.userinfo.map((data, i) => (
                    <div key={i} className="col-6 mb-3">
                      <h4>{data.title}</h4>
                      <p className="mb-0">{data.subtitle}</p>
                    </div>
                  ))}
                </div>
              </div>
              <ul className="social-icon mt-3">
                {socialLink.facebook === "" ? (
                  ""
                ) : (
                  <li>
                    <a href={socialLink.facebook} target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/facebook.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                )}
                {socialLink.twitter === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://cuo.irins.org/profile/61438/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/CuO.png"
                        alt="CUO"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}
                {socialLink.linkedin === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://www.efsle.org/sanjeet-kumar-das/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/eflse.png"
                        alt="eflse"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}
                {socialLink.youtube === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://vidwan.inflibnet.ac.in/profile/61438/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/research.png"
                        alt="sanjeet kumar das"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    // <!-- ========== Author section end ========== -->
  );
};

export default Aboutv6;
